// Scope discipline for the global Context registry: ambient-tagged entries
// survive a DC switch, page-scoped ones clear (leaks suppressed prompts). CJS.

// XXX: NAMING TRAP: KEY_AMBIENT here is a REGISTRY-LIFETIME flag -- "survives the
// XXX: editor's per-DC registry clear". It is NOT the engine's ambientContextNames()
// XXX: set in build-component-contexts.js, and a row tagged KEY_AMBIENT is NOT
// XXX: thereby in any DC's context. Nothing may treat this flag as availability.
// XXX: See docs/CONTEXT_AVAILABILITY.md.
const KEY_AMBIENT = "ambient";

class ContextRegistryScope {

  /** ******************* Public Static Methods *********************/

  static get KEY_AMBIENT() {
    return KEY_AMBIENT;
  }

  static isAmbientEntry(entry) {
    return entry?.registryScope === KEY_AMBIENT;
  }

  // Names to remove when the editor (re)loads a DC. Iterates the RAW map —
  // `referred` chains are not chased, each key clears on its own tag.
  static staleContextNames(rawContextsMap) {
    return Object.entries(rawContextsMap ?? {})
        .filter(([, entry]) => !ContextRegistryScope.isAmbientEntry(entry))
        .map(([name]) => name);
  }

}

module.exports = ContextRegistryScope;
module.exports.default = ContextRegistryScope;
